<div class="flex h-screen flex-col">
  <p-toolbar class="border-none rounded-none shrink-0">
    <ng-template pTemplate="start">
      <span class="font-semibold text-lg">{{ 'layout.appTitle' | translate }}</span>
    </ng-template>
    <ng-template pTemplate="center">
      <app-global-search />
    </ng-template>
    <ng-template pTemplate="end">
      <div class="flex items-center gap-1.5 me-2" [pTooltip]="'layout.myAvailability' | translate">
        <span
          class="h-2.5 w-2.5 rounded-full"
          [class.bg-green-500]="myPresenceStatus === 'Online'"
          [class.bg-amber-500]="myPresenceStatus === 'Busy'"
          [class.bg-gray-400]="myPresenceStatus === 'Away'"
        ></span>
        <p-select
          class="w-28"
          [options]="presenceOptions"
          optionLabel="label"
          optionValue="value"
          [ngModel]="myPresenceStatus"
          (ngModelChange)="setMyPresence($event)"
        />
      </div>
      <p-select
        class="w-24 me-1.5"
        [options]="languageOptions"
        optionLabel="label"
        optionValue="value"
        [ngModel]="language()"
        (ngModelChange)="setLanguage($event)"
        [ariaLabel]="'layout.language' | translate"
      />
      <p-button
        [icon]="isDarkMode() ? 'pi pi-sun' : 'pi pi-moon'"
        [text]="true"
        [rounded]="true"
        [ariaLabel]="(isDarkMode() ? 'layout.switchToLight' : 'layout.switchToDark') | translate"
        [pTooltip]="'layout.toggleTheme' | translate"
        tooltipPosition="bottom"
        (onClick)="toggleTheme()"
      />
      <app-notification-bell />
      <app-sound-settings />
      <p-button icon="pi pi-sign-out" [text]="true" [rounded]="true" [ariaLabel]="'layout.signOut' | translate" (onClick)="signOut()" />
    </ng-template>
  </p-toolbar>

  <p-toast />

  @if (connectionStatus() !== 'online') {
    <div
      class="flex shrink-0 items-center justify-center gap-2 py-1 text-center text-xs font-medium"
      [class.bg-amber-100]="connectionStatus() === 'reconnecting'"
      [class.text-amber-800]="connectionStatus() === 'reconnecting'"
      [class.bg-red-100]="connectionStatus() === 'offline'"
      [class.text-red-800]="connectionStatus() === 'offline'"
    >
      <i class="pi" [class.pi-spin]="connectionStatus() === 'reconnecting'" [class.pi-spinner]="connectionStatus() === 'reconnecting'" [class.pi-wifi]="connectionStatus() === 'offline'"></i>
      {{ (connectionStatus() === 'offline' ? 'layout.offline' : 'layout.reconnecting') | translate }}
    </div>
  }

  <ng-template #navLinks>
    <a
      *appHasPermission="'Tickets.ViewReports'"
      routerLink="/dashboard"
      routerLinkActive="bg-gray-100 dark:bg-gray-800"
      class="flex w-full items-center gap-3 rounded px-3 py-2 text-lg hover:bg-gray-100 md:h-11 md:w-11 md:justify-center md:px-0 dark:hover:bg-gray-800"
      [pTooltip]="'nav.dashboard' | translate"
      [tooltipPosition]="isRtl() ? 'left' : 'right'"
      (click)="sidebarOpen.set(false)"
    >
      <i class="pi pi-chart-line"></i>
      <span class="text-sm font-medium md:hidden">{{ 'nav.dashboard' | translate }}</span>
    </a>
    <a
      *appHasPermission="'Conversations.View'"
      routerLink="/conversations"
      routerLinkActive="bg-gray-100 dark:bg-gray-800"
      class="flex w-full items-center gap-3 rounded px-3 py-2 text-lg hover:bg-gray-100 md:h-11 md:w-11 md:justify-center md:px-0 dark:hover:bg-gray-800"
      [pTooltip]="'nav.inbox' | translate"
      [tooltipPosition]="isRtl() ? 'left' : 'right'"
      (click)="sidebarOpen.set(false)"
    >
      <i class="pi pi-inbox"></i>
      <span class="text-sm font-medium md:hidden">{{ 'nav.inbox' | translate }}</span>
    </a>
    <a
      *appHasPermission="'Tickets.View'"
      routerLink="/tickets"
      routerLinkActive="bg-gray-100 dark:bg-gray-800"
      class="flex w-full items-center gap-3 rounded px-3 py-2 text-lg hover:bg-gray-100 md:h-11 md:w-11 md:justify-center md:px-0 dark:hover:bg-gray-800"
      [pTooltip]="'nav.tickets' | translate"
      [tooltipPosition]="isRtl() ? 'left' : 'right'"
      (click)="sidebarOpen.set(false)"
    >
      <i class="pi pi-ticket"></i>
      <span class="text-sm font-medium md:hidden">{{ 'nav.tickets' | translate }}</span>
    </a>
    <a
      *appHasPermission="'Templates.View'"
      routerLink="/templates"
      routerLinkActive="bg-gray-100 dark:bg-gray-800"
      class="flex w-full items-center gap-3 rounded px-3 py-2 text-lg hover:bg-gray-100 md:h-11 md:w-11 md:justify-center md:px-0 dark:hover:bg-gray-800"
      [pTooltip]="'nav.templates' | translate"
      [tooltipPosition]="isRtl() ? 'left' : 'right'"
      (click)="sidebarOpen.set(false)"
    >
      <i class="pi pi-comments"></i>
      <span class="text-sm font-medium md:hidden">{{ 'nav.templates' | translate }}</span>
    </a>

    <div class="my-2 h-px w-full bg-gray-200 md:w-8 dark:bg-gray-700"></div>

    <a
      *appHasPermission="'Administration.WhatsAppAccounts.View'"
      routerLink="/administration/whatsapp-accounts"
      routerLinkActive="bg-gray-100 dark:bg-gray-800"
      class="flex w-full items-center gap-3 rounded px-3 py-2 text-lg hover:bg-gray-100 md:h-11 md:w-11 md:justify-center md:px-0 dark:hover:bg-gray-800"
      [pTooltip]="'nav.whatsappAccounts' | translate"
      [tooltipPosition]="isRtl() ? 'left' : 'right'"
      (click)="sidebarOpen.set(false)"
    >
      <i class="pi pi-mobile"></i>
      <span class="text-sm font-medium md:hidden">{{ 'nav.whatsappAccounts' | translate }}</span>
    </a>
    <a
      *appHasPermission="'Administration.SystemConfiguration.View'"
      routerLink="/administration/system-configuration"
      routerLinkActive="bg-gray-100 dark:bg-gray-800"
      class="flex w-full items-center gap-3 rounded px-3 py-2 text-lg hover:bg-gray-100 md:h-11 md:w-11 md:justify-center md:px-0 dark:hover:bg-gray-800"
      [pTooltip]="'nav.systemConfiguration' | translate"
      [tooltipPosition]="isRtl() ? 'left' : 'right'"
      (click)="sidebarOpen.set(false)"
    >
      <i class="pi pi-cog"></i>
      <span class="text-sm font-medium md:hidden">{{ 'nav.systemConfiguration' | translate }}</span>
    </a>
    <a
      *appHasPermission="'Administration.Departments.Manage'"
      routerLink="/administration/ticketing-config"
      routerLinkActive="bg-gray-100 dark:bg-gray-800"
      class="flex w-full items-center gap-3 rounded px-3 py-2 text-lg hover:bg-gray-100 md:h-11 md:w-11 md:justify-center md:px-0 dark:hover:bg-gray-800"
      [pTooltip]="'nav.ticketingConfiguration' | translate"
      [tooltipPosition]="isRtl() ? 'left' : 'right'"
      (click)="sidebarOpen.set(false)"
    >
      <i class="pi pi-sitemap"></i>
      <span class="text-sm font-medium md:hidden">{{ 'nav.ticketingConfiguration' | translate }}</span>
    </a>
    <a
      *appHasPermission="'Administration.WebChatWidget.Manage'"
      routerLink="/administration/webchat-config"
      routerLinkActive="bg-gray-100 dark:bg-gray-800"
      class="flex w-full items-center gap-3 rounded px-3 py-2 text-lg hover:bg-gray-100 md:h-11 md:w-11 md:justify-center md:px-0 dark:hover:bg-gray-800"
      [pTooltip]="'nav.webChatWidget' | translate"
      [tooltipPosition]="isRtl() ? 'left' : 'right'"
      (click)="sidebarOpen.set(false)"
    >
      <i class="pi pi-globe"></i>
      <span class="text-sm font-medium md:hidden">{{ 'nav.webChatWidget' | translate }}</span>
    </a>
    <a
      *appHasPermission="'Administration.ProviderDiagnostics.View'"
      routerLink="/administration/provider-diagnostics"
      routerLinkActive="bg-gray-100 dark:bg-gray-800"
      class="flex w-full items-center gap-3 rounded px-3 py-2 text-lg hover:bg-gray-100 md:h-11 md:w-11 md:justify-center md:px-0 dark:hover:bg-gray-800"
      [pTooltip]="'nav.providerDiagnostics' | translate"
      [tooltipPosition]="isRtl() ? 'left' : 'right'"
      (click)="sidebarOpen.set(false)"
    >
      <i class="pi pi-heart-fill"></i>
      <span class="text-sm font-medium md:hidden">{{ 'nav.providerDiagnostics' | translate }}</span>
    </a>
  </ng-template>

  <div class="flex flex-1 overflow-hidden">
    <aside class="hidden w-16 shrink-0 overflow-y-auto border-e border-gray-200 md:flex dark:border-gray-700">
      <nav class="flex flex-col items-center gap-1 p-2">
        <ng-container [ngTemplateOutlet]="navLinks" />
      </nav>
    </aside>

    <main class="flex-1 overflow-y-auto pb-16 md:pb-0">
      <router-outlet />
    </main>
  </div>

  <button
    type="button"
    class="fixed inset-x-0 bottom-0 z-30 flex h-14 items-center justify-center gap-2 border-t border-gray-200 bg-white text-sm font-medium shadow-lg md:hidden dark:border-gray-700 dark:bg-gray-900"
    (click)="sidebarOpen.set(true)"
    [attr.aria-label]="'layout.openMenu' | translate"
  >
    <i class="pi pi-bars"></i>
    <span>{{ 'layout.menu' | translate }}</span>
  </button>

  @if (sidebarOpen()) {
    <div class="fixed inset-0 z-40 bg-black/40 md:hidden" (click)="sidebarOpen.set(false)"></div>
    <aside class="fixed inset-y-0 start-0 z-50 w-64 overflow-y-auto bg-white p-2 shadow-xl md:hidden dark:bg-gray-900">
      <nav class="flex flex-col gap-1">
        <ng-container [ngTemplateOutlet]="navLinks" />
      </nav>
    </aside>
  }
</div>
